import React from "react"
import { Script } from "gatsby"
import { parse } from 'node-html-parser'

const TourCheckout = ({ blok }) => {
  // console.log(blok)
  if(!blok.shopifyBuyNowButton) return null
  
  try {
    const htmlDoc = parse(blok.shopifyBuyNowButton)
    // console.log(htmlDoc)
    const button = htmlDoc.getElementsByTagName('div')[0]?.outerHTML
    const script = htmlDoc.getElementsByTagName('script')[0]?.innerHTML

    return (
      <div id="checkout" className="container max-w-[700px] mx-auto py-10">
        <h2 className="text-3xl font-bold text-center">Reserve Your Spot Online</h2>
        <div className="py-5 text-center">Instant Booking Available Now!</div>
        <div className="flex justify-center">
          <div className="" dangerouslySetInnerHTML={{ __html: button }} />
        </div>
        <Script dangerouslySetInnerHTML={{ __html: script }} />
      </div>    
    )
  } catch (e) {
    return null
  }
  
};

export default TourCheckout;
